module.exports = __webpack_public_path__ + "assets/img/w-c-6.75312e48.png";